module.exports = __webpack_public_path__ + "../panel-assets/img/svg-map.38363296.svg";